import {AdminSchoolsTable} from './AdminSchoolsTable';

export default AdminSchoolsTable;
